import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Nicholas Simmons",
        title: "Lead Cleaner",
        biography: "Nicholas Simmons is an experienced lead cleaner known for his dedication to maintaining spotless and hygienic environments. With a keen eye for detail and commitment to excellence, he ensures every space is pristine and welcoming. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "111-222-3344",
            email: "nicholas.simmons@example.com",
            website: "www.nicholassimmons.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Cleaning Supervisor",
            "Sanitation Specialist",
            "Facility Maintenance Expert",
            "Lead Cleaner",
            "Safety Compliance Officer"
        ],
        skills: [
            { id: 1, title: "Deep Cleaning", progress: 95 },
            { id: 2, title: "Team Management", progress: 90 },
            { id: 3, title: "Health & Safety", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Emma White",
        title: "Service Coordinator",
        biography: "Emma White is an organized and efficient service coordinator dedicated to ensuring smooth operations and excellent customer satisfaction. With strong communication skills and attention to detail, she coordinates service schedules, manages client relationships, and supports teams to deliver outstanding results. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "111-222-3344",
            email: "emma.white@example.com",
            website: "www.emmawhite.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Customer Service Specialist",
            "Operations Coordinator",
            "Scheduling Expert",
            "Service Coordinator",
            "Client Relations Manager"
        ],
        skills: [
            { id: 1, title: "Scheduling", progress: 95 },
            { id: 2, title: "Client Communication", progress: 90 },
            { id: 3, title: "Team Coordination", progress: 85 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Jack Brown",
        title: "Stain Removal Specialist",
        biography: "Jack Brown is an expert stain removal specialist with extensive knowledge of advanced cleaning techniques and products. Known for his precision and effectiveness, Jack tackles the toughest stains and restores fabrics and surfaces to their best condition. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "111-222-3344",
            email: "jack.brown@example.com",
            website: "www.jackbrown.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Fabric Care Expert",
            "Advanced Cleaning Technician",
            "Stain Removal Specialist",
            "Surface Treatment Professional",
            "Cleaning Product Specialist"
        ],
        skills: [
            { id: 1, title: "Stain Removal", progress: 95 },
            { id: 2, title: "Fabric Care", progress: 90 },
            { id: 3, title: "Chemical Handling", progress: 85 }
        ]
    },
    {
        id: 4,
        image: images.team1,
        name: "Olivia Taylor",
        title: "Fabric Care Specialist",
        biography: "Olivia Taylor is a dedicated fabric care specialist with deep expertise in maintaining and restoring textiles. She combines technical knowledge with gentle care techniques to ensure every fabric retains its quality and longevity. Olivia’s passion for textile care makes her an invaluable member of the team. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum! Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "111-222-3344", 
            email: "olivia.taylor@example.com",
            website: "www.oliviataylor.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Textile Restoration Expert",
            "Fabric Care Specialist",
            "Laundry Technician",
            "Quality Control Analyst",
            "Customer Support Specialist"
        ],
        skills: [
            { id: 1, title: "Fabric Care", progress: 95 },
            { id: 2, title: "Textile Restoration", progress: 90 },
            { id: 3, title: "Quality Control", progress: 85 }
        ]
    }

];

export default team;